// Sidebar del rol Super Admin (Jidoka) — cross-tenant.

import { Sidebar, SidebarGroup, SidebarItem } from './SidebarNav';

export function SuperAdminSidebar() {
  return (
    <Sidebar>
      <SidebarGroup label="Jidoka">
        <SidebarItem to="/super-admin" end icon="factory">
          Tenants
        </SidebarItem>
        <SidebarItem to="/super-admin/salud" icon="gauge">
          Salud del sistema
        </SidebarItem>
        <SidebarItem to="/super-admin/auditoria" icon="chart-bar">
          Auditoría cross-tenant
        </SidebarItem>
      </SidebarGroup>
    </Sidebar>
  );
}
